@if (isShowAddToCartModal) {
  <section class="addtocartModal modal-wrap">
    <div class="box-dim" (click)="onCloseAddToCartModal()"></div>
    <div class="container">
      <header class="header">
        <h1>Add to Cart</h1>
        <h2>
          <!-- <a href="" [routerLink]="['/product', selectedProduct.id]">
          {{ selectedProduct.englishName }}</a
          > -->
        </h2>
      </header>
      <div class="contents">
        <div class="box-spec">
          <span
            ><span class="pink">{{ productService.cartsProductLength }}</span> items in cart</span
          >
          <span
            ><span class="pink">{{ selectedProducts.length }}</span> items selected</span
          >
          @if (productService.maxProduct - totalLength > 0) {
            <span
              >You can select <span class="pink">{{ productService.maxProduct - totalLength }}</span> more items</span
            >
          } @else {
            <span><span class="pink">Maximum selection reached.</span> Deselect items to add others.</span>
          }
        </div>
        <div class="selected-option-list">
          <strong class="title"
            >Selected Items <span>({{ sendSelectedProducts.length }})</span></strong
          >
          <div class="reset" (click)="reset()">Reset</div>
          <div style="margin-bottom: 14px">
            <mat-checkbox [checked]="isCheckedAll" (click)="clickAllSelect()" style="margin-right: 10px">
              <span> Select All </span>
            </mat-checkbox>
            <span class="delete-seleted" (click)="deleteSelect()">Delete Seleted</span>
          </div>
          <div class="scroll">
            <div>
              <div>
                <ul>
                  @for (saleProduct of selectedProducts; track saleProduct) {
                    <li
                      [ngClass]="{
                        'out-of-stock': saleProduct?.productOption.productStatus === PRODUCT_STATUS.OUT_OF_STOCK,
                      }"
                      (click)="addToSelect(saleProduct)"
                    >
                      <mat-checkbox class="checkbox" [checked]="saleProduct.addBulkChecked"></mat-checkbox>
                      <span class="thumb"
                        ><img src="{{ saleProduct ? (saleProduct?.productOption.images)[0].endpoint : '' }}"
                      /></span>
                      <strong>{{ saleProduct?.productOption.englishOptionName }}</strong>
                      <em>{{
                        saleProduct.productOption.productStatus !== PRODUCT_STATUS.OUT_OF_STOCK || null
                          ? '$' + (saleProduct.productOption.salePriceUSD | currency: 'USD' : '' : '0.2')
                          : ('BUTTON.OUT_OF_STOCK' | t)
                      }}</em>
                    </li>
                  }
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <a class="close" [innerHTML]="'BUTTON.CLOSE' | t" (click)="onCloseAddToCartModal()"></a>
      <div class="bulk-add-products" [class.disabled]="sendSelectedProducts.length === 0">
        <div (click)="addBulkProducts()" class="bulk-add-products-button">Add to cart</div>
      </div>
    </div>
  </section>
}
